"use client";

import { useState, useEffect } from "react";

export function ScheduleNowLine({
  dayStartMinutes,
  festivalDate,
  pixelsPerMinute = 2,
}: {
  dayStartMinutes: number;
  festivalDate: string;
  pixelsPerMinute?: number;
}) {
  const [nowMinutes, setNowMinutes] = useState<number | null>(null);

  useEffect(() => {
    function update() {
      const now = new Date();
      const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
      if (today !== festivalDate) {
        setNowMinutes(null);
        return;
      }
      setNowMinutes(now.getHours() * 60 + now.getMinutes());
    }

    update();
    const interval = setInterval(update, 60_000);
    return () => clearInterval(interval);
  }, [festivalDate]);

  if (nowMinutes === null) return null;

  const top = (nowMinutes - dayStartMinutes) * pixelsPerMinute;

  return (
    <div
      className="absolute left-0 right-0 z-20 pointer-events-none"
      style={{ top: `${top}px` }}
    >
      <div className="flex items-center">
        <div className="h-2.5 w-2.5 -ml-1 rounded-full bg-acid shadow-[0_0_8px_#D1F805]" />
        <div className="h-px flex-1 bg-acid/60" />
      </div>
    </div>
  );
}
